import { EventType } from './EventType';
/**
 * Live Activity manager.
 */
export class AirshipLiveActivityManager {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Lists any Live Activities for the request.
     * @param request The request options.
     * @returns A promise with the result.
     */
    list(request) {
        return this.plugin.perform('liveActivityManager#list', request);
    }
    /**
     * Lists all Live Activities.
     * @param request The request options.
     * @returns A promise with the result.
     */
    listAll() {
        return this.plugin.perform('liveActivityManager#listAll');
    }
    /**
     * Starts a Live Activity.
     * @param request The request options.
     * @returns A promise with the result.
     */
    start(request) {
        return this.plugin.perform('liveActivityManager#start', request);
    }
    /**
     * Updates a Live Activity.
     * @param request The request options.
     * @returns A promise with the result.
     */
    update(request) {
        return this.plugin.perform('liveActivityManager#update', request);
    }
    /**
     * Ends a Live Activity.
     * @param request The request options.
     * @returns A promise with the result.
     */
    end(request) {
        return this.plugin.perform('liveActivityManager#end', request);
    }
    /**
     * Adds a Live Activity listener.
     */
    onLiveActivityUpdates(listener) {
        return this.plugin.addListener(EventType.IOSLiveActivitiesUpdated, listener);
    }
}
//# sourceMappingURL=AirshipLiveActivityManager.js.map